






























































































































import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import CustomerFormModal from '@/web/components/customers/CustomerFormModal.vue';
import DeleteCustomerModal from '@/web/components/customers/DeleteCustomerModal.vue';
import Status from '@/web/components/customers/Status.vue';
import { mapGetters, mapState } from 'vuex';
import { errorToMessage } from '@/core/utils/errors';
import { getActivePunches } from '@/core/utils/classcards';
import { sanitize } from '@/core/utils/utils';
import HMInfoTile from '@/web/components/common/HMInfoTile.vue';
import CustomerProfileModal from '@/web/components/customers/CustomerProfileModal.vue';

export default Vue.extend({
  name: 'CustomerDetail',
  components: {
    TopNav,
    NavItem,
    Status,
    HMInfoTile,
  },
  computed: {
    selectedTab() {
      return this.$route.name;
    },
    ...mapState({
      customer: state => state.sale.customerDetail as CustomerResponse,
    }),
    ...mapGetters('sale', [
      'customerFullAddress',
      'customerPurchases',
      'customerUsedPunches',
      'customerAvailablePunches',
      'customerPunches',
      'customerStats',
    ]),
    ...mapGetters({
      studioURL: 'user/studioURL',
      teacher: 'user/teacher',
    }),
    getUserId() {
      return parseInt(this.$route.params.id);
    },
    query() {
      return {
        studentId: this.getUserId,
        q: this.search,
      };
    },
    getActivePunches() {
      return getActivePunches(this.customerPunches);
    },
    statusTexts() {
      return {
        'no-show': this.$t('EVENTS.LABEL.NO_SHOW'),
        registered: this.$t('EVENTS.LABEL.REGISTERED'),
        attended: this.$t('EVENTS.LABEL.ATTENDED'),
        recording: this.$t('EVENTS.LABEL.WATCHED_RECORDING'),
      };
    },
  },
  data() {
    return {
      search: null,
      tabs: [
        /*
        {
          name: 'customer-activity',
          title: this.$t('CUSTOMERS.LABEL.ACTIVITY'),
        },
        */
        {
          name: 'customer-events',
          title: this.$t('CUSTOMERS.LABEL.EVENTS'),
        },
        {
          name: 'customer-products',
          title: this.$t('CUSTOMERS.LABEL.PRODUCTS'),
        },
        {
          name: 'customer-class-card',
          title: this.$t('CUSTOMERS.LABEL.CLASS_CARD'),
        },
        {
          name: 'customer-notes',
          title: this.$t('CUSTOMERS.LABEL.NOTES'),
        },
        {
          name: 'customer-emails',
          title: this.$t('CUSTOMERS.LABEL.EMAILS'),
        },
        {
          name: 'customer-groups',
          title: this.$t('CUSTOMERS.LABEL.GROUPS'),
        },
        {
          name: 'customer-favorites',
          title: this.$t('CUSTOMERS.LABEL.FAVORITES'),
        },
        {
          name: 'customer-waivers',
          title: this.$t('CUSTOMERS.LABEL.WAIVERS'),
        },
      ],
    };
  },
  methods: {
    openCustomerProfileModal() {
      this.$modal.show(CustomerProfileModal, {
        customerId: this.customer.id,
        communityProfileId: this.customer.community_profile_id,
      });
    },
    selectTab(name) {
      this.$router.push({ name });
    },
    sanitize,
    editCustomer() {
      this.$modal.show(
        CustomerFormModal,
        { customer: this.customer },
        {},
        {
          'before-close': this.loadCustomerDetails,
        }
      );
    },
    deleteCustomer() {
      this.$modal.show(DeleteCustomerModal, { customerId: this.customer.id });
    },
    async loadCustomerDetails() {
      try {
        await this.$store.dispatch(
          'sale/getCustomerDetail',
          this.$route.params.id
        );
        await this.$store.dispatch('sale/getCustomerStats', {
          customerId: this.getUserId,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load customer details',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async sendLoginLink() {
      try {
        await this.$store.dispatch('sale/sendLoginLink', this.customer.id);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.LOGIN_LINK_SENT'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
  },
  async mounted() {
    this.loadCustomerDetails();
  },
  destroyed() {
    this.$store.dispatch('sale/clearCustomerDetail');
    this.$store.dispatch('sale/clearCustomerStats');
  },
});
